import React, { Component, ComponentType } from 'react';

import { compose } from 'redux';

import { withSnackbar, WithSnackbarProps } from 'notistack';

import { Connectable, TConnectableProps } from './Connectable.hoc';

import { IReportEntity } from '../../../../../../../../state/types';

import Translator from '../../../../../../../../helpers/TranslationHelper';

import { AccessibleButton } from '../../../../../../../../components/accessControl/components';

interface IOwnProps {
    data: IReportEntity;
    monitoredId: string;
}

type TProps = IOwnProps & TConnectableProps & WithSnackbarProps;

class ObjectRecalculation extends Component<TProps> {
    public render() {
        const { data, dateFormat } = this.props;
        const disabled = data.actions?.onClick?.disabled;

        return (
            <>
                <AccessibleButton
                    check={(privileges) => privileges.objectRecalculation}
                    disabled={disabled}
                    onClick={(event) =>
                        this.props.showObjectRecalculationDialog({
                            data,
                            monitoredId: this.props.monitoredId,
                            dateFormat,
                        })
                    }
                    fullWidth
                    style={{ justifyContent: 'flex-start' }}
                >
                    {Translator.translate(data.label)}
                </AccessibleButton>
            </>
        );
    }
}

export default compose(
    Connectable,
    withSnackbar
)(ObjectRecalculation) as ComponentType<IOwnProps>;
